import { CountoDirective } from './src/counto.directive';
import { CountoModule } from './src/counto.module';

export { CountoDirective, CountoModule };
export default CountoModule;
